import { Component, Inject, Input, SimpleChanges } from "@angular/core";
import { Chart } from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";
import {roundOfMaxsize} from '../common/common'
import { REGISTRY_APPLICATION } from "../../../../../global/tokens";

@Component({
  selector: "app-duration-diabetes-chart",
  templateUrl: "./duration-diabetes-chart.component.html",
  styleUrls: ["./duration-diabetes-chart.component.scss"],
})
export class DurationDiabetesChartComponent {
  @Input() dataInsight: any;
  public loading: boolean = true;

  constructor(
    @Inject(REGISTRY_APPLICATION) public application: string,
  ) {
  }

  ngOnChanges(changes: SimpleChanges) {
    if(this.application === 'Admin'){
      if (changes["dataInsight"] && changes['dataInsight'].firstChange) {
        document.fonts.ready.then(() => {
        this.createBarChart();
        this.loading = false;
      }).catch((err) => { 
        // even if the font failed to load the chart will be render
        this.createBarChart();
        this.loading = false;
      });
      }
    }else{
      if (changes["dataInsight"] && !changes["dataInsight"].firstChange) {
        document.fonts.ready.then(() => {
        this.createBarChart();
        this.loading = false;
      }).catch((err) => { 
        // even if the font failed to load the chart will be render
        this.createBarChart();
        this.loading = false;
      });
      }
    }
  }

  createBarChart() {
    const labels = [
      "0",
      "5",
      "10",
      "15",
      "20",
      "25",
      "30",
      "35",
      "40",
      "45",
      "50",
      "55",
      "60",
      "65",
      "70",
      "75",
      "80",
    ];
    const values = this.dataInsight?.duration;

    // --------------Calculate Max size----------------------------
    const highestValue = Math.max(...this.dataInsight?.duration)

    let {roundedMaxSize,stepSize}=roundOfMaxsize(highestValue)

    // ---------------------------------------------------------------------

    const canvas: any = document.getElementById("durationDiabetesChart");
    const ctx = canvas.getContext("2d");
    canvas.width = canvas.offsetWidth;
    canvas.height = 250;
    Chart.defaults.global.defaultFontFamily= 'Poppins, sans-serif'
    const chart = new Chart(ctx, {
      type: "bar",
      plugins: [ChartDataLabels],
      data: {
        labels: labels,
        datasets: [
          {
            label: "Participants",
            data: values,
            backgroundColor: "rgba(81,103, 163,1)",
            borderColor: "rgba(81,103, 163,1)",
            borderWidth: 1,
          },
        ],
      },
      options: {
        tooltips: {
          backgroundColor: "white",
          titleFontColor: "#000",
          bodyFontColor: "#000",
          borderColor: "#ccc",
          borderWidth: 1,
          titleFontSize:window.innerWidth < 768 ? 12 : 16,
          bodyFontSize: window.innerWidth < 768 ? 12 : 15,
        },
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          datalabels: {
            display: false,
          },
        },
        legend: {
          display: false,
        },
        scales: {
          xAxes: [
            {
              ticks: {
                fontSize:window.innerWidth < 768 ? 12 : 16,
                minRotation: window.innerWidth < 768 ? 45 : 0,
                maxRotation: window.innerWidth < 768 ? 45 : 0
              },
              gridLines: {
                display: false,
              },
              scaleLabel: {
                display: true,
                labelString: "Years",
                fontSize:window.innerWidth < 768 ? 14 : 18,
                fontColor: "rgba(62,62,62,1)",
                fontStyle:"500",
                fontFamily:"Montserrat,sans-serif"
              },
            },
          ],
          yAxes: [
            {
              ticks: {
                min: 0,
                max: roundedMaxSize,
                stepSize: stepSize,
                fontSize:window.innerWidth < 768 ? 12 : 16,
              },
              gridLines: {
                display: true,
              },
              scaleLabel: {
                display: true,
                labelString: "Participants",
                fontSize:window.innerWidth < 768 ? 14 : 18,
                fontColor: "rgba(62,62,62,1)",
                fontStyle:"500",
                fontFamily:"Montserrat,sans-serif"
              },
            },
          ],
        },
      },
    });
  }
}
